import DayTwoOperation from '@shell/models/day-two-operation';

export default class CertificateRotation extends DayTwoOperation {}
